import api from "./api";
import type { LoginCredentials, AdminUser, LoginResponse } from "@/types";

export const authAPI = {
  login: async (
    credentials: LoginCredentials
  ): Promise<{ success: string; message: AdminUser; data: LoginResponse }> => {
    try {
      const response = await api.post("/admin/login", credentials);

      return {
        success: response.data.success || false,
        message: response.data.message || "Login successful",
        data: response.data.data,
      };
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      throw new Error(error.response?.data?.message || "Login failed");
    }
  },

  verifyToken: async (): Promise<AdminUser> => {
    try {
      const response = await api.get("/auth/admin/verify");
      return response.data;
    } catch (error: any) {
      throw new Error(
        error.response?.data?.message || "Token verification failed"
      );
    }
  },

  logout: async (): Promise<void> => {
    try {
      await api.post("/auth/admin/logout");
    } catch (error) {
      console.error("Logout error:", error);
    }
  },
};
